import { useState, useEffect } from 'react';
import { Zap } from 'lucide-react';
import useGamificationStore from '../../stores/useGamificationStore';
import './XPToast.css';

/**
 * XPToast — Lightweight "+XP" floating toast near the header.
 *
 * Renders from the store's xpToastQueue, each item gets a float-up + fade-out
 * animation with a 2s lifetime. Stacks vertically if multiple arrive.
 */
export default function XPToast() {
  const xpToastQueue = useGamificationStore(s => s.xpToastQueue);
  const popXPToast = useGamificationStore(s => s.popXPToast);
  const [visible, setVisible] = useState([]); // [{ amount, id, key }]

  useEffect(() => {
    if (xpToastQueue.length === 0) return;

    const item = xpToastQueue[0];
    const key = `${item.timestamp}-${item.amount}`;

    setVisible(prev => [...prev, { amount: item.amount, key }]);
    popXPToast();

    // Auto-remove after animation
    const timer = setTimeout(() => {
      setVisible(prev => prev.filter(v => v.key !== key));
    }, 2000);

    return () => clearTimeout(timer);
  }, [xpToastQueue, popXPToast]);

  if (visible.length === 0) return null;

  return (
    <div className="xp-toast-container">
      {visible.map(item => (
        <div key={item.key} className="xp-toast">
          <Zap size={14} className="xp-toast__icon" />
          <span className="xp-toast__amount">+{item.amount} XP</span>
        </div>
      ))}
    </div>
  );
}
